<template>
  <div class="ohs-hazard-form">
    <form>
      <radio-input v-model="val.priority" :options="{
        label: 'Priority',
        radios: radios.PRIORITY,
        value: val.priority,
        fullWidth: true,
        inline: true,
        index
      }">
      </radio-input>
      <h3>Location</h3>
      <object-select-input
        @input="updateLocation($event)"
        :options="{
          name: 'locationTemplates',
          objects: locations,
          objectName: 'location',
          value: '',
          fullWidth: true
        }">
      </object-select-input>
      <textarea-input ref="location" v-model="val.location" :options="{
        name: 'location',
        value: val.location,
        fullWidth: true
      }">
      </textarea-input>
      <h3>Finding</h3>
      <object-select-input
        @input="updateFinding($event)"
        :options="{
          name: 'findingTemplates',
          objects: findings,
          objectName: 'finding',
          value: '',
          fullWidth: true
        }">
      </object-select-input>
      <textarea-input ref="finding" v-model="val.finding" :options="{
        name: 'finding',
        value: val.finding,
        fullWidth: true
      }">
      </textarea-input>
      <h3>Recommendation</h3>
      <textarea-input ref="recommendation" v-model="val.recommendation" :options="{
        name: 'recommendation',
        value: val.recommendation,
        fullWidth: true
      }">
      </textarea-input>
      <radio-input v-model="val.assessment" :options="{
        label: 'Assessment',
        radios: radios.ASSESSMENT,
        value: val.assessment,
        fullWidth: true,
        inline: true,
        index
      }">
      </radio-input>
      <radio-input v-model="val.costEstimate" :options="{
        label: 'Cost Estimate',
        radios: radios.COST_ESTIMATE,
        value: val.costEstimate,
        fullWidth: true,
        inline: true,
        index
      }">
      </radio-input>
    </form>
  </div>
</template>


<script>
  // import Api from '@/vuex/api'
  import {
    PRIORITY,
    ASSESSMENT,
    COST_ESTIMATE
  } from '@/OHSHazards'
  import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
  import RadioInput from '@/components/inputs/RadioInput'
  import TextareaInput from '@/components/inputs/TextareaInput'
  export default {
    name: 'OhsHazardForm',
    components: {
      ObjectSelectInput,
      RadioInput,
      TextareaInput
    },
    data () {
      return {
        radios: {
          PRIORITY,
          ASSESSMENT,
          COST_ESTIMATE
        },
        uuidRegex: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-4][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i
      }
    },
    props: {
      val: {
        type: Object
      },
      index: {
        type: Number
      },
      locations: {
        type: Array
      },
      findings: {
        type: Array
      }
    },
    methods: {
      async updateLocation (val) {
        let location = this.locations.find(el => el.uuid === val)
        this.$refs.location.validate(location.location)
      },
      async updateFinding (val) {
        let finding = this.findings.find(el => el.uuid === val)
        this.$refs.finding.validate(finding.finding)
        this.$refs.recommendation.validate(finding.recommendation)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/displays/OhsHazardForm.vue